import * as angular from "angular";
import { IntegrationErrorsDataProvider } from "../../data-provider/integration-errors.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { PermissionCheck } from "../../shared/permission";
import { ToastUtils } from "../../helper/toast.helper";

let IntegrationErrorsComponent = {
    selector: "vcIntegrationErrors",
    templateUrl:
        "/angular/components/integration/integration-errors.component.html",
    bindings: {},
    controller: class IntegrationErrorsController {
        public dataProvider: IntegrationErrorsDataProvider;
        public loading: boolean;
        public integrationKey: string;
        public resending: boolean;
        private readonly $scope: any;
        private dialog: DialogUtils;
        private $filter: any;
        private toast: ToastUtils;
        private permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            $routeParams: any,
            $filter: any,
            DialogUtils: DialogUtils,
            IntegrationErrorsDataProvider: IntegrationErrorsDataProvider,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.integrationKey = $routeParams.integrationKey;
            this.dataProvider = IntegrationErrorsDataProvider;
            this.$filter = $filter;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
        }

        $onInit() {
            this.loading = false;
            this.resending = false;
            this.dataProvider.setName(this.integrationKey);
            this.getAllErrors();
        }

        getAllErrors(): void {
            this.loading = true;
            this.dataProvider.getAllErrors(true).then(
                (errors: object[]) => {
                    if (errors.length == 0) {
                        this.resending = true;
                    }
                    this.loading = false;
                },
                () => {}
            );
        }

        push(): void {
            this.resending = true;
            this.dataProvider.push().then(() => {
                this.toast.success(
                    "All of these objects will be resent to " +
                        this.integrationKey +
                        ". This page will auto refresh when all objects have been resent."
                );
            });
        }

        convertSyncableType(syncable_type: string): string {
            if (syncable_type == "App\\Models\\Schema\\Canvass") {
                return "Interaction";
            } else if (syncable_type == "App\\Models\\Schema\\HouseOccupant") {
                return "Contact";
            }
            return syncable_type;
        }

        syncableDetails(data: any): any {
            if (
                data.integrationsync.syncable_type ==
                "App\\Models\\Schema\\HouseOccupant"
            ) {
                return {
                    primary: this.getContactName(data.houseoccupant),
                    secondary: this.getHouseAddress(data.house),
                };
            } else if (
                data.integrationsync.syncable_type ==
                "App\\Models\\Schema\\Canvass"
            ) {
                return {
                    primary: this.getContactName(data.houseoccupant),
                    secondary: this.getHouseAddress(data.house),
                };
            } else {
                return "N/A";
            }
        }

        showSyncableDialog(data: any, ev: any): void {
            if (
                data.integrationsync.syncable_type ==
                "App\\Models\\Schema\\HouseOccupant"
            ) {
                this.dialog.show({
                    component: "vc-view-house-occupant",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedHoid: data.houseoccupant.hoid,
                    },
                    ariaLabel: "View Person",
                    size: "large",
                });
            } else if (
                data.integrationsync.syncable_type ==
                "App\\Models\\Schema\\Canvass"
            ) {
                this.dialog.show({
                    component: "vc-canvass-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedCanvass: data.canvass,
                    },
                    size: "large",
                    ariaLabel: "Interaction",
                });
            }
        }

        showSyncableErrorDialog(
            integration_name: string,
            data: any,
            ev: any
        ): void {
            this.dialog
                .show({
                    component: "vc-general-info-code",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        bodyText:
                            "This contact could not be sent to " +
                            integration_name +
                            " due to the following error:",
                        title: `Sync Error`,
                        code: data.integrationsync.error,
                        buttonText: {
                            cancel: "",
                            confirm: "Dismiss",
                        },
                    },
                })
                .then((data) => {});
        }

        getContactName(data: any): string {
            return (
                (data.hofname != "" ? data.hofname : "Anonymous") +
                " " +
                (data.holname != "" ? data.holname : "Contact")
            );
        }

        getHouseAddress(data: any): string {
            if (
                data.haddress &&
                data.hcity &&
                data.hstate &&
                data.haddress != "" &&
                data.hcity != "" &&
                data.hcity != "" &&
                data.hstate != ""
            ) {
                var address =
                    data.hnumber +
                    " " +
                    data.haddress +
                    ", " +
                    data.hcity +
                    ", " +
                    data.hstate;

                address = address.replace(", , ", ", ");
                address = address.trim();

                return address;
            }
        }
    },
};

angular
    .module("integration", [])
    .component(IntegrationErrorsComponent.selector, IntegrationErrorsComponent);
